import { store } from "../store";
import Controller from "./Controller";
import apiClientEncrypt from "../plugins/axiosEncrypt";
import apiClientToken from "../plugins/axiosToken";
export default class Admin {    

    getUnidades(context){   
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServiciosAdmin + "WCFUnidades.svc/RestService/getUnidades")        
            .then(function(response){
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    login(context,params){
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientEncrypt.post(store.getters.getUrlServiciosAdmin + "WCFUsuarios.svc/RestService/LoginJWT",params)        
            .then(function(response){                
                if(response.data.ok)
                    resolve(controller.getData(context,response));
                else
                    reject(response.data);
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

}